
import { getAdminConfigApi } from "../../util/api";
import { storableError } from "../../util/errors";

// ================ Action types ================ //
export const FETCH_ADMIN_CONFIG_REQUEST =
    'app/TrustAndVerificationPage/FETCH_ADMIN_CONFIG_REQUEST';
export const FETCH_ADMIN_CONFIG_SUCCESS =
    'app/TrustAndVerificationPage/FETCH_ADMIN_CONFIG_SUCCESS';
export const FETCH_ADMIN_CONFIG_ERROR =
    'app/TrustAndVerificationPage/FETCH_ADMIN_CONFIG_ERROR';

// ================ Reducer ================ //
const initialState = {
    adminConfig: null,
    fetchAdminConfigInProgress: false,
    fetchAdminConfigError: null,
};

export default function reducer(
    state = initialState,
    action = {}
) {
    const { type, payload } = action;
    switch (type) {
        // Admin config
        case FETCH_ADMIN_CONFIG_REQUEST:
            return { ...state, fetchAdminConfigInProgress: true, fetchAdminConfigError: null };
        case FETCH_ADMIN_CONFIG_SUCCESS:
            return { ...state, fetchAdminConfigInProgress: false, adminConfig: payload, fetchAdminConfigError: null };
        case FETCH_ADMIN_CONFIG_ERROR:
            return { ...state, fetchAdminConfigInProgress: false, fetchAdminConfigError: payload };

        default:
            return state;
    }
}

// ================ Action creators ================ //
export const fetchAdminConfigRequest = () => ({ type: FETCH_ADMIN_CONFIG_REQUEST });
export const fetchAdminConfigSuccess = adminConfig => ({
    type: FETCH_ADMIN_CONFIG_SUCCESS,
    payload: adminConfig,
});
export const fetchAdminConfigError = error => ({
    type: FETCH_ADMIN_CONFIG_ERROR,
    error: true,
    payload: error,
});
// ================ Thunks ================ //

// loadData is a collection of async calls that need to be made
// before page has all the info it needs to render itself
export const getAdminConfig = () => async (dispatch, getState, sdk) => {
    try {
        dispatch(fetchAdminConfigRequest());
        const response = await getAdminConfigApi();
        dispatch(fetchAdminConfigSuccess(response.data));
    } catch (error) {
        console.error(error);
        dispatch(fetchAdminConfigError(storableError(error)));
    }
}
export const loadData = (params, search, config) => (dispatch, getState) => {
    return Promise.all([
        dispatch(getAdminConfig())
    ]);
};
